import React from 'react'
import Main from '../../organisms/Main/Main';

function Bedroom() {
  return <Main title='Sypialnia' category='bedroom' status='false' />;
}

export default Bedroom